"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.invertColorScale = exports.hexToRGB = void 0;
exports.hexToRGB = function (hex, alpha) {
    var r = parseInt(hex.slice(1, 3), 16);
    var g = parseInt(hex.slice(3, 5), 16);
    var b = parseInt(hex.slice(5, 7), 16);
    if (alpha) {
        return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
    }
    else {
        return "rgba(" + r + ", " + g + ", " + b + ")";
    }
};
exports.invertColorScale = function (scale) {
    return {
        c10: scale.c100,
        c20: scale.c90,
        c30: scale.c80,
        c40: scale.c70,
        c50: scale.c60,
        c60: scale.c50,
        c70: scale.c40,
        c80: scale.c30,
        c90: scale.c20,
        c100: scale.c10,
    };
};
//# sourceMappingURL=utils.js.map